import React, { FC, ReactElement, useContext, useMemo } from 'react'
import { SelectOptions } from '../Selects'
import CLanguageHandler from '../../../../NonReact/Languages/LanguageHandler'
import { LanguageContext } from '../../Contexts'
import { LinkInputLanguage } from '../../../../../i18n'
import { Rules } from '../../Types/Types'
import { ValidationErrors } from '../ValidationErrors/ValidationErrors'
import { OutlinedTextInput } from '../../../../ReactRouting/Components/Atoms/Inputs/OutlinedTextInput'
import { OutlinedSelect } from '../../../../ReactRouting/Components/Atoms/Inputs/OutlinedSelect'

type Props = {
    name: string
    label: string
    disabled?: boolean
    rules?: Rules
    textRules?: Rules
}

export const LinkInput: FC<Props> = ({ name, label, rules, disabled, textRules }: Props): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler
    language.loadBundle(LinkInputLanguage.NAME)

    const selectOptions: SelectOptions<string> = useMemo(
        (): SelectOptions<string> => [
            {
                label: language.get(LinkInputLanguage.LinkInput_NewTab),
                value: '_blank'
            },
            {
                label: language.get(LinkInputLanguage.LinkInput_CurrentTab),
                value: '_self'
            }
        ],
        []
    )

    const urlFieldName: string = useMemo((): string => `${name}.url`, [name])
    const titleFieldName: string = useMemo((): string => `${name}.title`, [name])

    return (
        <div className='link-input'>
            <div className='li-label'>{label}</div>
            <div className='li-inputs form-row'>
                <ValidationErrors name={urlFieldName}>
                    <OutlinedTextInput
                        className='li-text'
                        inputName={urlFieldName}
                        disabled={disabled}
                        rules={rules}
                        labelLeft={language.get(LinkInputLanguage.LinkInput_URL)}
                    />
                </ValidationErrors>
                <ValidationErrors name={titleFieldName}>
                    <OutlinedTextInput
                        className='li-text'
                        inputName={titleFieldName}
                        labelLeft={language.get(LinkInputLanguage.LinkInput_Title)}
                        disabled={disabled}
                        rules={textRules}
                    />
                </ValidationErrors>
                <OutlinedSelect
                    classNames='li-text'
                    options={selectOptions}
                    name={`${name}.target`}
                    label={language.get(LinkInputLanguage.LinkInput_Target)}
                    disabled={disabled}
                />
            </div>
        </div>
    )
}
